<template>
  <div class="detail">
    <app-header logo-link="/sell/listing" />
    <div class="detail-container">
      <!--       <section class="section-detail-top" v-if="coverGallery.length <= 2">
        <div class="section-detail-top--image">
          <div class="section-detail-top--image--single" v-lazy:background-image="coverGallery[0].url" v-if="coverGallery.length === 1 && coverGallery[0]"></div>
          <div class="section-detail-top--image--left" v-lazy:background-image="coverGallery[0].url" v-if="coverGallery.length === 2 && coverGallery[0]"></div>
          <div class="section-detail-top--image--right" v-lazy:background-image="coverGallery[1].url" v-if="coverGallery.length === 2 && coverGallery[1]"></div>
          <div class="view-btn" @click.stop="viewAlbum(coverGallery)">
            <i class="iconfont picture"></i>
            <span>{{ $t('viewPicture') }}</span>
          </div>
        </div>
      </section>
      <section class="section-detail-top" v-if="coverGallery.length > 2">
        <ImageSlider :imgs="coverGallery"></ >
        <div class="album-btn" @click="viewAlbum(coverGallery)">
          <i class="iconfont picture"></i>
          <span>{{ $t('viewAlbum') }}({{ coverGallery.length }})</span>
        </div>
      </section> -->
      <section v-if="info.coverGallery" class="section-detail-top">
        <div class="detail-info">
          <h2 class="title">{{ info.title }}</h2>
          <h4 v-if="info.subTitle" class="desp">{{info.subTitle}}</h4>
          <div class="rooms">
            <span v-if="info.houseTypeArray[0]">{{info.houseTypeArray[0]}}</b> Beds</span>
            <span v-if="info.houseTypeArray[1]">{{info.houseTypeArray[1]}}</b> Baths</span>
            <span v-if="info.sqft">{{ $formatMoney(info.sqft) }} Sq.Ft</span>
            <span v-if="info.lotSize">{{ $formatMoney(info.lotSize) }} Lot size</span>
          </div>
          <div class="rooms">
            <span class="capitalize">{{ info.familyType }} Family House</span>
          </div>
        </div>
        <CoverGallery :images="info.coverGallery"></CoverGallery>
      </section>
      <FixedAgentCard v-if="agentInfo" :info="agentInfo" @showDrawer="showDrawer"></FixedAgentCard>
      <ValidatePasswd v-if="needPasswd" :lang="currentApiLang" type="sell" @validated="handleDetailRes"></ValidatePasswd>
      <section v-if="!needPasswd" class="section-detail">
        <div v-if="description" class="desc-wrap">
          <div class="section-title">Description</div>
          <div class="desc" :class="{ showAll: isShowAll }" v-html="description"></div>
        </div>
        <SlideGallery v-if="docGallery.length" :images="docGallery"></SlideGallery>
        <div v-if="getYoutubeId" class="video">
          <div class="title">Video</div>
          <div class="youtube">
            <youtube ref="youtube" :video-id="getYoutubeId" width="566" height="289" :resize="true"></youtube>
          </div>
        </div>
        <div class="geo">
          <div class="section-title">{{ $t('location') }}
            <small><span v-if="info.geoInfo">
                {{
                info.geoInfo.city.length && info.geoInfo.city[0].name ? info.geoInfo.city[0].name[currentApiLang] : ''
                }}
                {{
                info.geoInfo.district.length && info.geoInfo.district[0].name
                ? info.geoInfo.district[0].name[currentApiLang]
                : ''
                }}
                {{ info.geoInfo.zip }}
              </span></small>
          </div>
          <div v-if="info.geoInfo" class="geo-map">
            <!-- test center: { lat: 29.5705292, lng: 106.4609418 } -->
            <GmapMap v-if="!isChina" class="geo-map-instance" :center="info.geoInfo.latlng" :zoom="mapZoom" :options="GmapOptions" map-type-id="terrain">
              <Gmap-marker :position="info.geoInfo.latlng" :icon="mapMarkerIcon"></Gmap-marker>
            </GmapMap>
            <BaiduMap v-else class="geo-map-instance" ak="eqcYd7HeRK04gMuOIpqYTegkWfw9Oda6" :center="info.geoInfo.latlng" :zoom="15" :scroll-wheel-zoom="true">
              <BmMaker :position="info.geoInfo.latlng" :dragging="true"></BmMaker>
            </BaiduMap>
          </div>
          <div v-if="isManual" class="geo-desc">
            <div v-for="(nearbyInfo, key) in nearbyInfoObj" :key="'nearbyInfo-' + key" class="geo--nearby">
              <div class="geo--nearby--img" :style="`background-image:url('${nearbyImg}')`"></div>
              <div class="geo--nearby--title">{{ $t(key) }}</div>
              <div class="geo--nearby--list">
                <div v-for="(n, nIndex) in nearbyInfo" :key="'nearby-id-' + nIndex">
                  <span v-if="n.facility && n.facility.name">{{ n.facility.name[currentApiLang] }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!isManual && nearbyList !== null" class="geo--nearby--box">
            <div class="geo--nearby--box--head">
              <div v-for="(nearbyItem, nearbyIndex) in typeList" :key="'type-' + nearbyIndex" class="geo--nearby--box--head--item" :class="{ 'geo--nearby--box--head--active': activeIndex === nearbyIndex }" @click="changeType(nearbyIndex)">
                {{ nearbyItem }}
              </div>
            </div>
            <div v-loading="nearbyLoading" class="pointer-list">
              <div v-for="(pointer, pointerIndex) in nearbyList" :key="'nearby-item-' + pointerIndex" class="pointer-item" @click="pointerClick(pointer)">
                <div class="pointer-item-left">
                  {{ pointer.name }}
                  <div v-if="pointer.rating" class="pointer-item-left-rate">{{ pointer.rating.toFixed(1) }}</div>
                </div>
                <div class="pointer-item-right">{{ pointer.distance }} miles</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 房产详情 -->
        <div class="more-info">
          <div class="section-title">{{ $t('houseDetail') }}</div>
          <div v-if="info.detail" class="more-info-items">
            <span v-if="info.detail.builtYear">{{ $t('showBuiltYear', { year: info.detail.builtYear }) }}</span>
            <span v-if="info.sqft">{{ $formatMoney(info.sqft) }} Sq.Ft</span>
            <span v-if="info.lotSize">{{ $formatMoney(info.lotSize) }} Lot size</span>
            <span v-if="info.detail.parking">{{ $t('showParking', { num: info.detail.parking }) }}</span>
            <span v-if="info.detail.room">{{ info.detail.room }} rooms</span>
            <span v-if="info.detail.storeroom">{{ $t('showStoreRoom', { num: info.detail.storeroom }) }}</span>
            <!-- 前六个为一类处理规则 -->
            <span v-for="fac in allFacilityList" v-if="fac.name" :key="'fac-' + fac.id">
              <font-icon v-if="fac.icon" :id="fac.icon"></font-icon>
              {{ fac.name[currentApiLang] }}
            </span>
            <!-- <span>
              {{ $t('heating') }}:
              {{ getArrTextByLang(info.detail.facility.heating, currentApiLang) }}
            </span>
            <span>
              {{ $t('cooling') }}:
              {{ getArrTextByLang(info.detail.facility.cooling, currentApiLang) }}
            </span>
            <span v-if="info.detail.facility.parking && info.detail.facility.parking.length">Attached Garage</span>
            <span>极简欧式装修</span>
            <span>Contemporary Architecture</span>
            <span>
              {{ getArrTextByLang(info.detail.facility.floor, currentApiLang) }}
              {{ $t('floor') }}
            </span>
            <span>
              {{ getArrTextByLang(info.detail.facility.roof, currentApiLang) }}
              {{ $t('roof') }}
            </span>-->
          </div>
        </div>
        <!-- 费用详情 -->
        <div class="fee-detail">
          <div class="section-title">{{ $t('feeDetails') }}</div>
          <div class="fee--total">
            <span>{{ $t('totalPriceOfHouse') }}</span>
            <span class="fee--total--num">{{ info.price | currency(currencyConfig) }}</span>
          </div>
          <div v-if="showNeedLoan" class="fee-toggle">
            <span :class="{ active: !isFullPayment }">{{ $t('needLoan') }}</span>
            <el-switch v-model="isFullPayment" class="switcher" active-color="#99D20D" inactive-color="#99D20D"></el-switch>
            <span :class="{ active: isFullPayment }">{{ $t('fullPayment') }}</span>
          </div>
          <div class="fee--list">
            <!-- left -->
            <div v-if="!isFullPayment" class="fee--list--left">
              <!-- 每月支出 -->
              <div v-if="priceCalc.interestRate || priceCalc.interestRate ===0" class="fee--list--item">
                <span class="fee--list--label">{{ $t('loanLang.interestRate') }}</span>
                <span class="fee--list--rate">
                  <el-popover placement="bottom" width="306" trigger="click" @hide="showTooltip1 = false">
                    <el-slider v-model="priceCalc.interestRate" class="pagebuy-rate-slider" :width="306"
                      :format-tooltip="val => `${val}%`" :show-tooltip="showTooltip1" @input="showTooltip1 = true" />
                    <span slot="reference" class="fee--list--rate--btn">{{ priceCalc.interestRate }}%</span>
                  </el-popover>
                </span>
                <span class="fee--list--content">{{ interestRateComputed | currency(currencyConfig) }}</span>
              </div>
              <div class="fee--list--item">
                <span class="fee--list--label">{{ $t('monthlyExpenditure') }}</span>
                <span class="fee--list--content">{{ costOfPerMonth | currency(currencyConfig) }}</span>
              </div>

              <div v-if="priceCalc.propertyTax" class="fee--list--item">
                <span class="fee--list--label">{{ $t('feeLang.propertyTaxes') }}</span>
                <span class="fee--list--content">{{ priceCalc.propertyTax | currency(currencyConfig) }}</span>
              </div>
              <div v-if="priceCalc.hoaFee" class="fee--list--item">
                <span class="fee--list--label">{{ $t('feeLang.HOA') }}</span>
                <span class="fee--list--content">{{ priceCalc.hoaFee | currency(currencyConfig) }}</span>
              </div>
              <div v-if="priceCalc.insurance" class="fee--list--item">
                <span class="fee--list--label">{{ $t('feeLang.insurance') }}</span>
                <span class="fee--list--content">{{ priceCalc.insurance | currency(currencyConfig) }}</span>
              </div>
              <div v-if="priceCalc.mortgageInsurance" class="fee--list--item">
                <span class="fee--list--label">{{ $t('feeLang.mortgageInsurance') }}</span>
                <span class="fee--list--content">{{ priceCalc.mortgageInsurance | currency(currencyConfig) }}</span>
              </div>
            </div>
            <!-- left 全款 -->
            <div v-else class="fee--list--left">
              <div v-if="fullPaymentCostOfPerMonth" class="fee--list--item">
                <span class="fee--list--label">{{ $t('monthlyExpenditure') }}</span>
                <span class="fee--list--content">{{ fullPaymentCostOfPerMonth | currency(currencyConfig) }}</span>
              </div>
              <div v-if="priceCalc.propertyTax" class="fee--list--item">
                <span class="fee--list--label">{{ $t('feeLang.propertyTaxes') }}</span>
                <span class="fee--list--content">{{ priceCalc.propertyTax | currency(currencyConfig) }}</span>
              </div>
              <div v-if="priceCalc.hoaFee" class="fee--list--item">
                <span class="fee--list--label">{{ $t('feeLang.HOA') }}</span>
                <span class="fee--list--content">{{ priceCalc.hoaFee | currency(currencyConfig) }}</span>
              </div>
              <div v-if="priceCalc.insurance" class="fee--list--item">
                <span class="fee--list--label">{{ $t('feeLang.insurance') }}</span>
                <span class="fee--list--content">{{ priceCalc.insurance | currency(currencyConfig) }}</span>
              </div>
            </div>
            <!-- right -->
            <div v-if="!isFullPayment" class="fee--list--right">
              <div class="fee--list--item">
                <span class="fee--list--label">{{ $t('downPayment') }}</span>
                <span class="fee--list--content">{{ totalDownPayment | currency(currencyConfig) }}</span>
              </div>
              <div class="fee--list--item">
                <span class="fee--list-label">{{ $t('loanLang.mortgagePeriod') }}</span>
                <span>
                  <el-dropdown trigger="click" @command="setYears">
                    <span class="fee--list--dropdown">{{ priceCalc.years }} {{ $t('loanLang.years') }}</span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="year in loanYearsEnmu" :key="'year-' + year" :command="year">{{ year }} years</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
              </div>
              <div class="fee--list--item">
                <span class="fee--list--label">{{ $t('loanLang.downPaymentRate') }}</span>
                <span class="fee--list--rate">
                  <el-popover placement="bottom" width="306" trigger="click" @hide="showTooltip2 = false">
                    <el-slider v-model="priceCalc.downPayment" class="pagebuy-rate-slider" :width="306" :format-tooltip="val => `${val}%`" :show-tooltip="showTooltip2" @input="showTooltip2 = true" />
                    <span slot="reference" class="fee--list--rate--btn">{{ priceCalc.downPayment }}%</span>
                  </el-popover>
                </span>
                <span class="fee--list--content">{{ downPaymentComputed | currency(currencyConfig) }}</span>
              </div>
              <div v-if="priceCalc.closingCost" class="fee--list--item">
                <span class="fee--list--label">Closing fee</span>
                <span class="fee--list--content">{{ priceCalc.closingCost | currency(currencyConfig) }}</span>
              </div>
            </div>
            <!-- right 全款(存在买卖手续费才显示)) -->
            <div v-else-if="priceCalc.closingCost" class="fee--list--right">
              <div class="fee--list--item">
                <span class="fee--list--label">Total price</span>
                <span class="fee--list--content">{{ fullPaymentTotalPrice | currency(currencyConfig) }}</span>
              </div>
              <div class="fee--list--item">
                <span class="fee--list--label">Listing price</span>
                <span class="fee--list--content">{{ info.price | currency(currencyConfig) }}</span>
              </div>
              <div class="fee--list--item">
                <span class="fee--list--label">Closing fee</span>
                <span class="fee--list--content">{{ priceCalc.closingCost | currency(currencyConfig) }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 评分 -->
        <div class="rate">
          <div class="rate-rated">
            <div v-if="info.selfRate && info.selfRate.length" class="rate-agent">
              <div class="rate-rated-title">{{ $t('agentRate') }}</div>
              <app-rating v-for="(r, i) in info.selfRate" :key="'selfRate-' + i" class="rating-item" :number="r.star" :disabled="true">
                <span class="rating-item--text color-black">{{ r.text }}</span>
              </app-rating>
            </div>
            <div v-if="info.rateHistory" class="rate-user">
              <div class="rate-rated-title">{{ $t('userRate') }}</div>
              <app-rating class="rating-item" :number="getHistoryRate" :disabled="true">
                <span class="color-gray">{{ info.rateHistory.rate || 0 }} / {{ info.rateHistory.count }} {{ $t('rates') }}</span>
              </app-rating>
            </div>
          </div>
          <div class="rate-action">
            <app-rating class="rating-item" :number="getHistoryRate" :disabled="isHasRated" @change="currentRateChange"></app-rating>
            <div v-if="showSubmitBtn" class="rating-btn" @click="updateRate(currentRate)">{{ $t('submitRates') }}</div>
            <p v-else>{{ isHasRated ? $t('hasRated') : $t('whatThinkOf') }}</p>
          </div>
        </div>
        <!-- 评论 -->
        <detail-comment :house="info" :house-i-d="info.id" :is-sell="true"></detail-comment>
        <detail-date class="detail-date" :date-info="dateInfo" :house="info" :is-sell="true" :show-box="showDateBox" @closeDateBox="showDateBox = false"></detail-date>
        <!-- 社区详情 -->
        <div v-if="communityComments.length" class="community-detail">
          <div class="section-float-centered">
            <div class="section-title">{{ $t('communityDetails') }}</div>
            <div class="subtitle">
              <span>{{ $t('localSay') }}</span>
              <span>*{{ $t('dataFrom') }}</span>
            </div>
            <div class="list">
              <span v-for="(comment, i) in communityComments" :key="'communityComment-' + i">{{ comment.name }}</span>
            </div>
          </div>
        </div>
        <!-- 法律 -->
        <div class="legal-detail">
          <div class="legal-detail--link">
            <span>Local Legal Protections</span>
            <font-icon id="info" class="iconfont"></font-icon>
            <a href="http://www.lgbtmap.org/">http://www.lgbtmap.org/</a>
          </div>
          <div class="desc">Do legal protections exist for the LGBT community at the state level in ?</div>
        </div>
        <!-- 相似 -->
        <!-- <div class="similar" v-if="similarList.length">
          <div class="section-float-centered">
            <div class="section-title">{{ $t('similarSellRecommendations') }}</div>
            <div class="similar-slider-wrap">
              <Similar :similarList="similarList"></Similar>
            </div>
          </div>
        </div> -->
      </section>
      <section v-if="!needPasswd" class="section-float">
        <FloatingPriceCard :info="info" />
        <!-- <floating-price :info="info" /> -->
      </section>
    </div>
    <app-footer />
  </div>
</template>
<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import FloatingPriceCard from '@/components/buydetail/FloatingPriceCard.vue'
// import ImageSlider from '@/components/buydetail/ImageSlider.vue'
import Similar from '@/components/buydetail/similar.vue'
// import convertSellGallery from '@/common/convert-gallery-data'
import convertSellGallery from '@/common/convert-sell-gallery'
import pointerClick from '@/common/pointerClick'
import convertGalleryData from '@/common/convert-gallery-data'

import GmapStyles from 'map-style'
import CONFIG from '@/common/config'
import mapMarkerIcon from '@/assets/images/map-marker.png'
import checkNeedPassword from '@/common/check-need-password.js'
// eslint-disable-next-line
import fancyBox from '@fancyapps/fancybox'
import DetailComment from '../components/DetailComment'
import AppRating from '@/components/rentdetail/AppRating.vue'
import DetailDate from '../components/DetailDate'
import jstz from 'jstz'
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmMaker from 'vue-baidu-map/components/overlays/Marker.vue'
import FixedAgentCard from '@/components/FixedAgentCard'

import CoverGallery from '@/components/CoverGallery.vue'
import SlideGallery from '@/components/SlideGallery'
import getLinkInfo from '@/common/get-link-info'
import ValidatePasswd from '@/components/ValidatePasswd'


export default {
  components: {
    DetailDate,
    DetailComment,
    AppHeader,
    AppFooter,
    FloatingPriceCard,
    // ImageSlider,
    Similar,
    AppRating,
    BaiduMap,
    BmMaker,
    FixedAgentCard,
    CoverGallery,
    SlideGallery,
    ValidatePasswd
  },
  mixins: [pointerClick, getLinkInfo],
  data() {
    return {
      agentInfo: null,
      currentApiLang: 'en-US',
      nearbyLoading: false,
      houseID: this.$route.params.id,
      info: {},
      mapZoom: CONFIG.DEFAULT_MAP_ZOOM,
      GmapOptions: {
        styles: [
          ...GmapStyles.dark,
          {
            featureType: 'transit',
            stylers: [{ color: '#d59563', visibility: 'off' }],
          },
        ],
      },
      mapMarkerIcon,
      sliders1_imgs: [],
      sliders1_init_index: 2,
      sliders1_big_img: {},
      isFloating: false,
      isShowAll: true,
      isFullPayment: false,
      nearbyImg: require('../assets/images/detail-map.png'),
      loanYearsEnmu: [10, 15, 20, 30],
      priceCalc: {
        interestRate: 3.7, // 贷款利率
        downPayment: 30, // 首付比例(百分比)
        years: 20,
        propertyTax: 0, // 不动产税
        insurance: 0, // 业主保险
        hoaFee: 0, // 物业费
        closingCost: 0, // 房产买卖手续费
        mortgageInsurance: 0, // 贷款保险
      },
      rate1: 10,
      rate2: 10,
      communityComments: [],
      currencyConfig: {
        symbol: '$',
        thousandsSeparator: ',',
        fractionCount: 2,
        fractionSeparator: '.',
        symbolPosition: 'front',
        symbolSpacing: '',
      },
      numConfigInt: {
        symbol: '',
        thousandsSeparator: ',',
        fractionCount: 0,
        fractionSeparator: '.',
        symbolPosition: 'front',
        symbolSpacing: '',
      },
      shareInfoType: this.$route.params.type,
      shareInfoAgent: this.$route.params.agent,
      shareInfoUser: this.$route.params.user,
      shareInfoId: this.$route.params.id,
      activeIndex: 0,
      typeList: ['School', 'Transportation', 'Restaurants', 'Shopping', 'Health', 'Facility'],
      nearbyList: [],
      similarList: [],
      activeImage: 0,
      currentRate: 0,
      showSubmitBtn: false,
      showDateBox: false,
      dateInfo: {},
      isChina: false,
      showTooltip1: false,
      showTooltip2: false,
      roomNum: null,
      showRoomNum: false,
      docGallery: [],
      needPasswd: false,
      type: 'sell',
    }
  },
  computed: {
    description() {
      let description = this.info.description
      if (description) {
        return description.replace(
          '<p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https://www.froala.com/wysiwyg-editor?pb=1" title="Froala Editor">Froala Editor</a></p>',
          ''
        )
      }
      return description
    },
    isSharePage() {
      return !!this.shareInfoAgent
    },
    isManual() {
      // true手动 false自动
      if (this.info && this.info.geoInfo && this.info.geoInfo.isManual) {
        return this.info.geoInfo.isManual
      }
      return false
    },
    nearbyInfoObj() {
      if (!this.info.geoInfo) return {}
      const nearby = this.info.geoInfo.nearby
      delete nearby.primary // primary 不是 array
      return nearby
    },
    allFacilityList() {
      const list = []
      const facility = this.info.detail.facility
      Object.keys(facility).forEach(key => {
        const arr = facility[key]
        arr.forEach(obj => {
          list.push(obj)
        })
      })

      return list
    },
    loanOfPerMonth() {
      // 每月贷款
      const sellPrice = this.info.price
      const priceCalc = this.priceCalc
      const interestRate = priceCalc.interestRate * 0.01 // 贷款利率
      const term = priceCalc.years * 12
      const x = Math.pow(1 + interestRate, term)

      const num1 = sellPrice - sellPrice * priceCalc.downPayment * 0.01
      const num2 = interestRate * x

      return parseFloat((num1 * num2) / (x - 1)).toFixed(0)
    },
    interestRateComputed() {
      const price = Number(this.info.price)
      const interestRate = Number(this.priceCalc.interestRate)
      return parseFloat(price * interestRate * 0.01).toFixed(2)
    },
    downPaymentComputed() {
      const price = Number(this.info.price)
      const rate = Number(this.priceCalc.downPayment)
      return parseFloat(price * rate * 0.01).toFixed(2)
    },
    costOfPerMonth() {
      // 每月支出
      const priceCalc = this.priceCalc
      if(this.priceCalc.interestRate === 0){
        return this.info.price / priceCalc.years /12
      }
      return (
        Number(this.loanOfPerMonth) +
        priceCalc.propertyTax +
        priceCalc.mortgageInsurance +
        priceCalc.hoaFee +
        priceCalc.insurance
      )
    },
    totalDownPayment() {
      // 首付合计
      return parseFloat(this.costOfPerMonth + this.priceCalc.closingCost).toFixed(2)
    },
    fullPaymentTotalPrice() {
      const num = Number(this.info.price) + this.priceCalc.closingCost
      return parseFloat(num).toFixed(2)
    },
    fullPaymentCostOfPerMonth() {
      const priceCalc = this.priceCalc
      const num = priceCalc.propertyTax + priceCalc.hoaFee + priceCalc.insurance
      return parseFloat(num).toFixed(2)
    },
    getHistoryRate() {
      if (this.info && this.info.hasRated) {
        return this.info.ratedInfo.rate
      }
      return 0
    },
    isHasRated() {
      if (this.info && this.info.hasRated) {
        return this.info.hasRated
      }
      return this.hasRated
    },
    getYoutubeId() {
      if (this.info && this.info.youtube && this.info.youtube[0]) {
        return this.$youtube.getIdFromUrl(this.info.youtube[0].link)
      }
      return false
    },
    player() {
      return this.$refs.youtube.player
    },
    slideImageNum() {
      if (this.info && this.info.gallery) {
        let totalNum = 0
        this.info.gallery.forEach(gallery => {
          totalNum += gallery.photoList.length
        })
        if (totalNum === 0) {
          return 1
        } else if (totalNum === 1) {
          return 2
        }
      }
      return false
    },
    showNeedLoan() {
      if (
        this.fullPaymentCostOfPerMonth === 0 &&
        this.priceCalc.propertyTax === 0 &&
        this.priceCalc.hoaFee === 0 &&
        this.priceCalc.insurance === 0
      ) {
        return false
      }
      return true
    },
    // coverGallery() {
    //   return convertSellGallery(this.info)
    // },
  },
  watch: {
    '$store.state.apiLang': {
      immediate: true,
      handler(val) {
        this.currentApiLang = val
      },
    },
  },
  created() {
    this.getInfo()
    const timezone = jstz.determine()
    if (timezone.name() === 'Asia/Shanghai') {
      this.isChina = true
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    // getDescription() {
    //   let description = ''

    //   Object.assign(description, this.description)
    //   description.replace(
    //     '<p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https://www.froala.com/wysiwyg-editor?pb=1" title="Froala Editor">Froala Editor</a></p>',
    //     ''
    //   )
    //   return description
    // },
    getInfo() {
      this.openFullLoading()

      // 分享页
      if (this.isSharePage) {
        this.getLinkInfo(this.type)
      } else {
        this.getDetailInfo()
      }


    },
    getDetailInfo() {
      // 正常详情页
      this.$axios({
          url: '/api/v1/client/estate/sell/getDetailByUniqueTitle/' + this.houseID,
          // url: '/api/v1/client/estate/sell/getDetailByUniqueTitle/bai-mo-mi-85K6',
          method: 'get',
        })
        .then(res => {
          this.handleDetailRes(res)

          // this.loadSimilar()

        })
        .catch(err => {
          console.error(err)
          this.closeFullLoading()
          this.loading = false
        })
    },
    handleDetailRes(res) {
      this.closeFullLoading()
      this.info = res.doc
      this.agentInfo = res.doc.agent
      this.docGallery = convertGalleryData(res.doc)
      this.needPasswd = res.needPasswd

      if (this.needPasswd) return

      if (!this.info.geoInfo.isManual) {
        this.getNearbyInfo()
        this.changeType()
      }
      const { priceDetail } = res.doc



      this.priceCalc = Object.assign({}, this.priceCalc, priceDetail)
      if (res.doc.communityInfo && res.doc.communityInfo.community && res.doc.communityInfo.community[0]) {
        const community = res.doc.communityInfo.community[0]
        const communityId = typeof community === 'string' ? community : community.id
        this.getCommunity(communityId)
      }

      if (!this.info.geoInfo.isManual) {
        this.changeType()
      }

      // this.sliders1_big_img = this.docGallery[this.sliders1_current_index]
    },
    getNearbyInfo() {
      if (!this.info.geoInfo) return
      const nearby = this.info.geoInfo.nearby
      const res = []
      Object.keys(nearby).forEach(name => {
        if (Array.isArray(nearby[name])) {
          const itemList = nearby[name]
          itemList.forEach(item => {
            if (item.id)
              res.push({
                id: item.id,
                name: (item.facility && item.facility.name) || {},
                distance: item.distance,
                time: item.time,
              })
          })
        }
      })
      return res
    },

    getCommunity(communityId) {
      this.$axios({
          url: '/api/v1/client/estate/getCommunity/' + communityId,
          method: 'get',
        })
        .then(res => {
          this.communityComments = res.community.itemList || []
        })
        .catch(() => {
          console.log('err on getCommunity')
        })
    },
    openFullLoading() {
      this.loader = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
    },
    closeFullLoading() {
      this.loader.close()
    },
    setYears(year) {
      this.priceCalc.years = year
    },
    onSlide1(obj) {
      this.sliders1_big_img = this.sliders1_imgs[obj.currentSlide]
    },
    onSlide2() {
      // console.log(c)
    },
    currentRateChange(num) {
      this.currentRate = num
      this.showSubmitBtn = true
    },
    updateRate(num) {
      this.$axios({
          url: '/api/v1/client/estate/updateRate',
          method: 'post',
          data: { id: this.info.id, rate: num },
        })
        .then(res => {
          console.log(res)
          this.hasRated = true
          this.showSubmitBtn = false
        })
        .catch(() => {
          this.closeFullLoading()
          this.loading = false
        })
    },
    getArrTextByLang(resultArr, apiLang) {
      const strArr = resultArr.map(c => c.name[apiLang])
      return strArr.join(',')
    },
    changeType(index = 0) {
      this.nearbyList = []
      this.activeIndex = index
      let data = {
        lng: this.info.geoInfo.latlng.lng,
        lat: this.info.geoInfo.latlng.lat,
        type: this.typeList[index].toLowerCase(),
        language: 'en-US',
        distanceUnit: 'mile',
      }
      this.nearbyLoading = true
      this.$axios({

          url: 'https://map-api2.unicapsule.com/nearby',

          method: 'post',
          data: data,
        })
        .then(res => {
          this.nearbyLoading = false
          if (res && res.results && res.results.length) {
            this.nearbyList = res.results
          }
        })
        .catch(err => {
          this.nearbyLoading = false
          console.log(err)
          this.nearbyList = null
        })
    },
    // pointerClick(location) {
    //   let googleLink
    //   try {
    //     let origin = this.info.geoInfo.parsed_address.formatted_address
    //     let dest = location.name
    //     let destId = location.place_id
    //     googleLink = `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${dest}&destination_place_id=${destId}&travelmode=walking`
    //   } catch {
    //     let pointStr = location.geometry.location.lat + ',' + location.geometry.location.lng
    //     googleLink = `https://www.google.com/maps/search/?api=1&query=${pointStr}`
    //   }
    //   window.open(googleLink)
    // },
    loadSimilar() {
      if (
        this.info &&
        this.info.geoInfo &&
        this.info.geoInfo.city &&
        this.info.geoInfo.city[0] &&
        this.info.geoInfo.city[0].id
      ) {
        this.$axios({
          url: '/api/v1/client/estate/getRelatedList?city=' + this.info.geoInfo.city[0].id + '&type=sell&limit=10',
          method: 'get',
        }).then(res => {
          if (res && res.docs && res.docs.length) {
            this.similarList = res.docs
          }
        })
      }
    },
    viewAlbum(images) {
      let _this = this
      let items = []
      images.forEach(image => {
        items.push({
          src: image.url,
          opts: {
            caption: image.name + '<br />' + image.desp,
            desc: image.desp,
            thumb: image.url,
            height: window.innerHeight * 0.6,
            beforeClose: function(current) {
              _this.activeImage = current.currIndex
            },
          },
        })
      })
      $.fancybox.open(
        // items
        items,
        // options
        {
          loop: true,
          buttons: ['zoom', 'thumbs', 'close'],
        },
        _this.activeImage
      )
    },
    showDrawer(info) {
      this.dateInfo = info
      this.showDateBox = true
    },
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop === 2090) {
        if (this.info.youtube[0].autostart) {
          this.player.playVideo()
        }
      }
    },
  },
}

</script>
<style lang="less" scoped>
@import url('../assets/less/var.less');
@import '~@fancyapps/fancybox/src/css/core.css';
@import '~@fancyapps/fancybox/src/css/thumbs.css';

@section-detail-top-content-height: 410px;

.section-detail-top {

  width: 100%;
  height: @section-detail-top-content-height;
  position: relative;

  .detail-info {
    position: absolute;
    z-index: 1;
    background: rgba(0, 0, 0, .5);
    color: #fff;
    padding: 10px 20px 20px;
    bottom: 0;
    left: 0;
    max-width: 60%;
    min-width: 40%;

    .date {
      font-size: 12px;
    }

    .title {
      font-size: 26px;
      letter-spacing: 0.1em;
      margin-top: 5px;
      margin-bottom: 10px;
      font-weight: 700
    }

    .desp {
      font-size: 14px;
      margin: 0;
      margin-top: 10px;
    }

    .rooms {
      font-size: 12px;
      margin-top: 17px;

      &>span::after {
        content: '·';
        font-size: 12px;
        transform: scale(2);
        display: inline-block;
        margin: 0 8px;
      }

      &>span:last-child::after {
        display: none;
      }
    }
  }

  .album-btn {
    position: absolute;
    right: 38px;
    bottom: 15px;
    padding: 5px 13px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    text-align: center;
    line-height: 27px;
    font-size: 12px;
    color: rgba(255, 255, 255, 1);
    cursor: pointer;

    .iconfont {
      padding-right: 10px;
      line-height: 27px;
      font-size: 16px;
      vertical-align: middle;
    }
  }

  .view-btn {
    position: absolute;
    left: 16px;
    bottom: 21px;
    padding: 5px 13px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    text-align: center;
    line-height: 27px;
    font-size: 12px;
    color: rgba(255, 255, 255, 1);
    cursor: pointer;

    .iconfont {
      padding-right: 10px;
      line-height: 27px;
      font-size: 16px;
      vertical-align: middle;
    }
  }
}

.fs13 {
  font-size: 13px;
}


.color-gray {
  color: #898989;
}

.color-black {
  color: rgba(0, 0, 0, 0.85);
}

// .main {
//   position: relative;
//   width: @main-content-width;
//   margin: 0 auto;
//   box-sizing: border-box;
// }

.section-detail {
  color: rgba(0, 0, 0, 0.9);



  .desc-wrap {
    position: relative;
  }

  .desc {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 2;
    max-height: 80px;
    overflow-y: hidden;
    // float: left;
  }

  .desc.showAll {
    max-height: none;
  }

  .show-all {
    position: absolute;
    bottom: 0;
    left: 0;
    background: #fff;
    color: #9ecf40;
    text-align: center;
    width: 100%;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
  }

  .video {
    .title {
      margin-bottom: 34px;
      padding-top: 57px;
      width: 130px;
      height: 20px;
      font-size: 17px;
      color: rgba(0, 0, 0, 1);
      line-height: 22px;
      vertical-align: top;
    }
  }

  .imgs {
    margin-bottom: 57px;

    .img-container {
      position: relative;
      width: 659px;
      height: 422px;
      background: #eee;
      margin-bottom: 7px;

      img {
        width: 659px;
        height: 422px;
      }

      .img-desc {
        position: absolute;
        bottom: 24px;
        right: 16px;
        width: 246px;
        box-sizing: border-box;
        padding: 14px 10px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.76);
        font-size: 13px;
        color: rgba(0, 0, 0, 0.85);

        .icon {
          position: absolute;
          top: 14px;
          right: 9px;
        }

        p {
          margin: 0;
        }

        p:first-child {
          font-size: 14px;
          margin-bottom: 10px;
          width: 80%;
        }
      }
    }
  }

  .geo {
    font-size: 14px;


    .geo-map {
      width: 100%;
      height: 353px;
      margin-bottom: 22px;
    }

    .geo-map-instance {
      width: 100%;
      height: 353px;
    }

    .geo-map-marker {
      width: 32px;
      height: 32px;
    }


    .geo-desc {
      .geo--nearby {
        width: 188px;
        text-align: left;
        font-size: 14px;
        display: inline-block;
        vertical-align: top;
      }

      .geo--nearby--img {
        height: 80px;
        width: 80px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
      }

      .geo--nearby--title {
        margin-top: 12px;
        color: rgba(0, 0, 0, 0.85);
      }

      .geo--nearby--list {
        margin-top: 3px;
        line-height: 1.5;
        color: rgba(0, 0, 0, 0.5);
      }
    }

    .geo--nearby--box {
      height: 270px;

      .geo--nearby--box--head {
        display: flex;
        height: 30px;
        line-height: 30px;
        border-bottom: 1px solid rgba(224, 224, 224, 0.5);

        .geo--nearby--box--head--item {
          display: inline-block;
          margin-right: 38px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.5);
          cursor: pointer;
        }

        .geo--nearby--box--head--active {
          color: rgba(0, 0, 0, 0.85);
        }
      }

      .pointer-list {
        width: 100%;
        height: 240px;
        overflow-y: auto;

        .pointer-item {
          display: flex;
          height: 40px;
          line-height: 40px;
          cursor: pointer;

          .pointer-item-left {
            display: inline-block;
            width: 80%;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            .pointer-item-left-rate {
              display: inline-block;
              margin-left: 8px;
              width: 41px;
              height: 20px;
              line-height: 20px;
              background: rgba(153, 210, 13, 1);
              border-radius: 3px;
              font-size: 12px;
              color: rgba(255, 255, 255, 1);
              text-align: center;
            }
          }

          .pointer-item-right {
            display: inline-block;
            width: 20%;
            text-align: right;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.5);
          }
        }
      }

      ::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .rooms {
    .rooms-title {
      margin-bottom: 12px;
    }

    .room-desc {
      margin-top: 20px;
    }

    .room-desc-item {
      display: inline-block;
      width: 328px;
      box-sizing: border-box;
      margin-bottom: 34px;
      vertical-align: top;

      p {
        padding-left: 25px;
        line-height: 1;
        margin-bottom: 14px;
      }

      p:first-child {
        padding-left: 0;
      }

      .room-desc-item--title {
        display: inline-block;
        width: 90%;
        vertical-align: top;
        line-height: 1.3;
      }
    }
  }

  .more-info {

    .more-info-items {
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;

      >span {
        width: 32%;
        margin-bottom: 20px;
        display: flex;
        align-items: center;

        .iconfont {
          margin-right: 4px;
        }

        &::before {
          display: inline-block;
          content: '·';
          color: #bbb;
          margin-right: 10px;
          transform: scale(2);
        }
      }
    }

    .more-info-items--option {
      &::after {
        content: ',';
      }

      margin-right: 4px;
    }

    .more-info-items--option:last-child {
      &::after {
        display: none;
      }
    }
  }

  .fee-detail {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);

    .fee--total,
    .fee--list--left,
    .fee--list--right {
      width: 255px;
    }

    .fee--total {
      margin-top: 28px;
      display: flex;
      justify-content: space-between;
    }

    .fee--total--num {
      color: #99d20d;
      font-size: 18px;
    }

    .fee-toggle {
      margin-top: 20px;

      span.active {
        color: #99d20d;
      }
    }

    .switcher {
      margin: 0 22px;
    }

    .fee--list {
      margin-top: 19px;

      .fee--list--item {
        margin-bottom: 19px;
      }
    }

    .fee--list--left,
    .fee--list--right {
      display: inline-block;
      vertical-align: top;
    }

    .fee--list--right {
      margin-left: 50px;
    }

    .fee--list--item {
      position: relative;
      display: flex;
      justify-content: space-between;
    }

    .fee--list--content {
      color: #99d20d;
    }

    .fee--list--rate--btn,
    .fee--list--dropdown {
      display: inline-block;
      padding: 0 6px;
      border-bottom: 2px solid #99d20d;
      cursor: pointer;
      outline: none;
    }
  }
}

.rate {
  padding: 13px 21px;
  box-sizing: border-box;
  border-radius: 8px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);

  .rate-agent {
    display: inline-block;
    vertical-align: top;
    width: 280px;
  }

  .rate-user {
    display: inline-block;
    margin-right: 20px;
    vertical-align: top;
    width: 220px;
  }

  .rate-rated-title {
    margin-bottom: 19px;
  }

  .rating-item {
    margin-bottom: 13px;

    .rating-item--text {
      display: inline-block;
      padding: 0 0 0 30px;
      width: 120px;
      vertical-align: text-top;
    }

    .color-gray {
      padding-left: 30px;
    }
  }

  .rate-action {
    text-align: center;
    margin-top: 28px;

    p {
      margin-top: 13px;
    }

    .rating-btn {
      margin: 20px auto;
      width: 119px;
      height: 38px;
      background: rgba(153, 210, 13, 1);
      border-radius: 5px;
      font-size: 14px;
      color: rgba(249, 249, 249, 1);
      text-align: center;
      line-height: 38px;
      cursor: pointer;
    }
  }
}

.section-float {
  padding-bottom: 62px;

}

.community-detail {
  background-color: #fafafa;
  padding: 24px 0 41px;

  .subtitle {
    display: flex;
    margin-top: 11px;
    justify-content: space-between;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
  }

  .list {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 17px;

    span {
      display: inline-block;
      vertical-align: middle;
      width: 270px;
      margin-bottom: 17px;
    }
  }
}

.legal-detail {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  padding: 26px 0 62px;

  .legal-detail--link {
    font-size: 16px;

    a {
      color: #99d20d;
      font-size: 14px;
      text-decoration: none;
    }
  }

  .iconfont {
    color: #99d20d;
    margin: 0 10px 0 8px;
  }

  .desc {
    margin-top: 19px;
  }
}

.similar-slider-wrap {
  margin-top: 26px;
}

.section-float {
  position: sticky;
  top: 160px;
  height: 96px;
  /* height 与 margin-top保持一致 */
  z-index: 1;
}

.detail-date {
  position: fixed;
  right: 50px;
  bottom: 0;
  z-index: 2000;
}

@media (max-width: 767px) {
  .section-detail-top {
    height: auto;
    display: block;

    .detail-info {
      position: relative;
      max-width: none;
      min-width: 0;
      padding: 16px;
      background: rgba(0, 0, 0, .74);

      .title {
        font-size: 22px;
        line-height: 1.3;
        letter-spacing: 0;
        word-break: break-word;
      }

      .rooms {
        display: flex;
        flex-wrap: wrap;
        gap: 8px 12px;
        line-height: 1.4;

        > span::after {
          display: none;
        }
      }
    }
  }

  .section-detail {
    margin-top: 20px;

    .video {
      .title {
        width: auto;
        padding-top: 24px;
        margin-bottom: 16px;
      }

      .youtube {
        position: relative;
        overflow: hidden;
        width: 100%;
        padding-top: 56.25%;
      }
    }

    .geo {
      .geo-map,
      .geo-map-instance {
        height: 260px;
      }

      .geo--nearby--box {
        .geo--nearby--box--head {
          overflow-x: auto;
          white-space: nowrap;

          .geo--nearby--box--head--item {
            margin-right: 24px;
            flex: 0 0 auto;
          }
        }
      }
    }

    .more-info {
      .more-info-items {
        > span {
          width: 100%;
          margin-bottom: 14px;
        }
      }
    }

    .fee-detail {
      .fee--total,
      .fee--list--left,
      .fee--list--right {
        width: 100%;
      }

      .fee--list--right {
        margin-left: 0;
      }
    }
  }

  .rate {
    padding: 16px;

    .rate-agent,
    .rate-user {
      display: block;
      width: 100%;
      margin-right: 0;
    }
  }

  .community-detail {
    padding: 20px 0;

    .list span {
      width: 100%;
    }
  }

  .legal-detail {
    padding: 20px 0 40px;
    word-break: break-word;
  }

  .section-float {
    position: static;
    width: 100%;
    height: auto;
    padding-bottom: 24px;
    order: 2;
  }

  .detail-date {
    right: 10px;
    left: 10px;
    width: auto;
  }
}
</style>
